<template>
  <el-tabs v-model="activeName">
    <el-tab-pane label="待审核" name="list">
      <List ref="list" />
    </el-tab-pane>
    <el-tab-pane label="审核记录" name="history">
      <History ref="history" />
    </el-tab-pane>
  </el-tabs>
</template>
<script>
import List from './List.vue';
import History from './History.vue';

export default {
  name: 'verify-sample',
  components: {
    List,
    History,
  },
  data() {
    return {
      activeName: 'list',
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (to.params.status === 'toListTab1') {
        vm.activeName = 'list';
        vm.$refs.list.selectTab = 'Tab1';
        vm.$nextTick(() => {
          vm.$refs[vm.activeName].onSearch();
        });
      }
    });
  },
  watch: {
    activeName(val) {
      if (val === 'list' || val === 'history') {
        this.$refs[val].getList();
      }
    },
  },
  methods: {},
};
</script>
